/* eslint-disable react/destructuring-assignment */

import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';

import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import { AppFileField } from '../../form/appFileField';
import { required } from '../../form/formValidations';
import FormModal from '../../modal/formModal';
import { AppSelectField } from '../../form/appSelectField';

import * as NotificationHelper from 'helpers/notificationHelper';

interface UploadParticipantsFormOwnProps {
  eventId: string;
  onSuccessCallback?: () => void;
}

interface UploadParticipantsFormState {
  option: UploadParticipantsOptions;
}

enum UploadParticipantsOptions {
  REPLACE = 'replace',
  MERGE = 'merge',
  MARCHING_ORDER = 'marchingOrder',
  EVENT_SPLIT = 'eventSplit',
  MO_DATA = 'marchingOrderData',
}

// eslint-disable-next-line react/prefer-stateless-function
export default class UploadParticipantsForm extends React.Component<
  UploadParticipantsFormOwnProps,
  UploadParticipantsFormState
> {
  actionOptions = [
    {
      value: UploadParticipantsOptions.REPLACE,
      label: 'Remove the old list and upload the new one',
    },
    {
      value: UploadParticipantsOptions.MERGE,
      label: 'Update the current list',
    },
    {
      value: UploadParticipantsOptions.MARCHING_ORDER,
      label: 'Update MarchingOrder list',
    },
    {
      value: UploadParticipantsOptions.EVENT_SPLIT,
      label: 'Event split',
    },
    {
      value: UploadParticipantsOptions.MO_DATA,
      label: 'Update MO order, audio, slide',
    },
  ];

  constructor(props: any) {
    super(props);

    this.state = {
      option: UploadParticipantsOptions.REPLACE,
    };
  }

  actionType = () => {
    switch (this.state.option) {
      case UploadParticipantsOptions.REPLACE:
        return DataRequestActionTypes.UploadParticipantsRequested;
      case UploadParticipantsOptions.MERGE:
        return DataRequestActionTypes.UploadParticipantsWithMergeRequested;
      case UploadParticipantsOptions.MARCHING_ORDER:
        return DataRequestActionTypes.UploadParticipantsFromMarchingOrder;
      case UploadParticipantsOptions.EVENT_SPLIT:
        return DataRequestActionTypes.UploadParticipantsWithEventSplit;
      case UploadParticipantsOptions.MO_DATA:
        return DataRequestActionTypes.UploadParticipantsMarchingOrderData;
      default:
        NotificationHelper.error('Selected action is not supported');
    }

    return undefined;
  };

  public render() {
    return (
      <FormModal
        formId={FormId.UploadParticipants}
        formTitle="Upload Participants"
        submitActionType={this.actionType()}
        reduxData={{ eventId: this.props.eventId }}
        buttonIcon={faArrowUp}
        invertedButtonColours
        onSuccessCallback={this.props.onSuccessCallback}
      >
        <AppSelectField
          name="replaceParticipants"
          label="Action"
          options={this.actionOptions}
          onChange={(_, newValue) => this.setState({ option: newValue })}
          validate={[required]}
        />
        <AppFileField name="participantsFile" label="CSV/XLSX File" validate={[required]} />
      </FormModal>
    );
  }
}
